export interface Testimonial {
  quote: string;
  author: string;
  context: string;
}

export function TestimonialsSection({ testimonials }: { testimonials: Testimonial[] }) {
  if (testimonials.length === 0) return null;

  return (
    <section className="testimonials-section section-pad" aria-labelledby="testimonials-title">
      <div className="section-heading centered">
        <div className="eyebrow">Persönliche Erfahrungen</div>
        <h2 id="testimonials-title">Was Schüler und Eltern sagen.</h2>
      </div>
      <div className="testimonial-grid">
        {testimonials.map((testimonial) => (
          <figure className="testimonial-card" key={`${testimonial.author}-${testimonial.quote}`}>
            <blockquote>„{testimonial.quote}“</blockquote>
            <figcaption><strong>{testimonial.author}</strong><span>{testimonial.context}</span></figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
